// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------
import * as selfUtil from '@/utils/ZBKJIutil.js';
import router from "@/router";
export default function useDeviseDiy() {
  var frontDomain = "".concat(selfUtil.getFrontDomainUrl());
  // 预览
  var previewProtol = function previewProtol(id) {
    if (!id) return;
    var perViewDia = {};
    perViewDia.perViewUrl = frontDomain + '?id=' + id;
    perViewDia.visible = true;
    return perViewDia;
  };
  // 添加、编辑、赋值
  var onEditDiyPage = function onEditDiyPage(id, type, fromTo) {
    var _router$resolve = router.resolve({
        path: "/page/design/creatDevise/".concat(id, "/").concat(type)
      }),
      href = _router$resolve.href;
    window.open(href);
  };
  return {
    previewProtol: previewProtol,
    onEditDiyPage: onEditDiyPage
  };
}